var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileCertified = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V8.25C18 8.66421 17.6642 9 17.25 9C16.8358 9 16.5 8.66421 16.5 8.25V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V21C1.5 21.8284 2.17157 22.5 3 22.5H9.30446C9.71867 22.5 10.0545 22.8358 10.0545 23.25C10.0545 23.6642 9.71867 24 9.30446 24H3C1.34314 24 0 22.6569 0 21V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75C4.5 6.33579 4.83579 6 5.25 6H12.75C13.1642 6 13.5 6.33579 13.5 6.75C13.5 7.16421 13.1642 7.5 12.75 7.5H5.25C4.83579 7.5 4.5 7.16421 4.5 6.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75C4.5 9.33579 4.83579 9 5.25 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5.25C4.83579 10.5 4.5 10.1642 4.5 9.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H8.25C8.66421 12 9 12.3358 9 12.75C9 13.1642 8.66421 13.5 8.25 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 24C20.9779 24 24 20.9779 24 17.25C24 13.5221 20.9779 10.5 17.25 10.5C13.5221 10.5 10.5 13.5221 10.5 17.25C10.5 20.9779 13.5221 24 17.25 24ZM17.25 22.5C20.1495 22.5 22.5 20.1495 22.5 17.25C22.5 14.3505 20.1495 12 17.25 12C14.3505 12 12 14.3505 12 17.25C12 20.1495 14.3505 22.5 17.25 22.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7891 16.0097C21.0703 15.7285 21.0703 15.2725 20.7891 14.9913C20.5078 14.71 20.0518 14.71 19.7706 14.9913L16.1697 18.2938L14.7294 16.4316C14.4482 16.1504 13.9922 16.1504 13.7109 16.4316C13.4297 16.7128 13.4297 17.1688 13.7109 17.4501L15.6605 19.8215C15.9418 20.1028 16.3977 20.1028 16.679 19.8215L20.7891 16.0097Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileCertified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-certified.53c0a6c709013edc72fb9524dc263ec9.svg";